import React, { useEffect, useRef, useState } from "react";
import {
  CButton,
  CModal,
} from "@carrefour/design-system-components-react";
import "reactjs-popup/dist/index.css";
import { useStores } from "../../context/storesContext";
import { ToastOptions, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom";
import { AlertStatus } from "../../utils/alertUtils";
import "./AlertActionPlan.css";
import styled from "styled-components";

type AlertActionPlanProps = {
  show: boolean;
  status: AlertStatus;
  alertSeriesId: string;
  deadlineDate?: string;
  onClose?: () => void;
  actionPlanSubmitted: () => void;
};

const AlertActionPlan: React.FC<AlertActionPlanProps> = ({
  show,
  status,
  alertSeriesId,
  deadlineDate,
  onClose,
  actionPlanSubmitted
}) => {

  const needsConfirmation =
    status === AlertStatus.NEW ||
    status === AlertStatus.IGNORED ||
    status === AlertStatus.TOADJUST;

  const { selectedStore } = useStores();
  const [open, setOpen] = useState(show);
  const [openCloseConfirmation, setOpenCloseConfirmation] = useState(false);

  const FooterContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
  `;

  const notify = (state: string) => {
    const options: ToastOptions = {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };
    if (state === "success") {
      toast.success("Sauvegarde réussie !", options);
    } else {
      toast.error("Une erreur est survenue lors de la sauvegarde.", options);
    }
  };

  const formRef = useRef<any>(null);
  const [selectedTheme, setSelectedTheme] = useState<string | null>(null);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    if (!formRef.current) return;

    const formEl = formRef.current;
    const handler = (event: CustomEvent) => {
      if (actionPlanSubmitted) {
        actionPlanSubmitted();
      }
      console.log("Form submitted: " + JSON.stringify(event.detail));
      setOpen(false);
      onClose?.();
      notify(event.detail);
    };
    formEl.addEventListener("formSubmit", handler);

    const handleThemeChange = (event: CustomEvent) => {
    console.log("Theme changed:", event.detail);
    setSelectedTheme(event.detail);
    };
    formEl.addEventListener("selectedThemeChange", handleThemeChange);

    return () => {
      formEl.removeEventListener("formSubmit", handler);
      formEl.removeEventListener("selectedThemeChange", handleThemeChange);
    };
  }, [open, onClose, actionPlanSubmitted]);


  return ReactDOM.createPortal(
    <>
      <CModal
        className="alert-action-plan"
        show={open}
        title="Plan d'action"
        showBackButton={!!selectedTheme}
        onBack={() => setSelectedTheme(null)}
        onClose={() => {
          if (needsConfirmation) {
            setOpenCloseConfirmation(true);
            setOpen(true);
          } else {
            setOpen(false);
            onClose?.();
          }
        }}
        position="right"
      >
        <app-action-plan-form
          ref={formRef}
          store-key={selectedStore?.storeKey}
          selected-theme={selectedTheme}
          alert-series-id={alertSeriesId}
          deadline-date-value={deadlineDate}
          mode={status === AlertStatus.NEW || status === AlertStatus.IGNORED ? "create" : (status === AlertStatus.TOADJUST ? "edit" : "view")}
        ></app-action-plan-form>
      </CModal>
      {needsConfirmation ? (
      <CModal
        show={openCloseConfirmation}
        onClose={() => { setOpenCloseConfirmation(false); }}
        title="Souhaitez-vous quitter sans enregistrer ?"
        position="center"
        size={"s"}
        footer={
          <FooterContainer>
            <CButton variation="tertiary" onClick={() => { setOpen(false); setOpenCloseConfirmation(false); onClose?.(); }}>Quitter sans enregistrer</CButton>
            <CButton onClick={() => {setOpenCloseConfirmation(false) }}>Revenir</CButton>
          </FooterContainer>
        }
      >
      </CModal>) : null}
      </>, document.body 
  );
};

export default AlertActionPlan;